// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 90) return "static/chunks/90-9853e961c1015511.js";
	if (chunkId === 127) return "static/chunks/127-94f0741b33d6703a.js";
	if (chunkId === 914) return "static/chunks/914-a31ee0922038f752.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"563":"1be2e4a0e89b24d1","795":"b8ab558d67c0786a","837":"23e011a1c5508cde"}[chunkId] + ".js";
};